import React, { useEffect, useState } from "react";
import { Package } from "lucide-react";
import api from "../../lib/api";

export function OrdersTab() {
  const [orders, setOrders] = useState(null);

  useEffect(() => {
    api.get("/member/orders").then((r) => setOrders(r.data)).catch(() => setOrders([]));
  }, []);

  if (orders === null) return <p className="text-[#8A9492]">Loading…</p>;

  return (
    <div data-testid="orders-tab">
      <h2 className="font-heading text-2xl font-light text-ink mb-6">Order history</h2>
      {orders.length === 0 ? (
        <div className="bg-white rounded-2xl p-10 border border-slate-100 text-center" data-testid="orders-empty">
          <Package className="h-8 w-8 text-[#c9c4dc] mx-auto" />
          <p className="text-[#8A9492] mt-3">No orders yet. Your product purchases will appear here.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map((o) => (
            <div key={o.id} className="bg-white rounded-2xl p-6 border border-slate-100" data-testid={`order-${o.id}`}>
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-[#8A9492]">
                  {new Date(o.created_at).toLocaleDateString()} · Order #{o.id.slice(0, 8)}
                </span>
                <span className="font-heading text-lg text-ink">${o.amount.toFixed(2)}</span>
              </div>
              <ul className="space-y-2">
                {o.items.map((it, i) => (
                  <li key={i} className="flex items-center gap-3 text-sm">
                    <img src={it.image} alt={it.name} className="h-9 w-9 rounded-md object-cover" />
                    <span className="flex-1 text-[#5C6664]">{it.name} × {it.qty}</span>
                    <span className="text-ink">${(it.unit_price * it.qty).toFixed(2)}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
